import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

interface IMessageTailProps {
    color: COLORS,
    width?: number,
    height?: number,
}

/**
 * @notes Является неотьемлемой частью компонента [ChatMessage]:
 * @link '@r1-frontend/ui-react/components/ChatMessage'
 *
 * Используется только внутри него, никак не связан с компонентами Icons
 * и не может быть приведен к ним
 */
const MessageTail = ({
    color,
    width = 42,
    height = 63,
}: IMessageTailProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 42 63'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.5 1.5C5.5 -3.23686 0 14.0811 0 28.9918C0 46.6649 14.3269
                 60.9917 32 60.9917C35.2201 60.9917 38.3291 60.5161 41.2606 59.6313C31.2206
                 56.2053 24 46.6918 24 35.4918C24 34.9882 24.0146 34.4881 24.0434
                 33.9918H24C24 33.9918 23.5 6.23686 14.5 1.5Z'
                fill={color}/>
        </svg>
    );
};

export default MessageTail;
